import { render, staticRenderFns } from "./CommitmentConfig.vue?vue&type=template&id=fa00b560&"
import script from "./CommitmentConfig.vue?vue&type=script&lang=js&"
export * from "./CommitmentConfig.vue?vue&type=script&lang=js&"
import style0 from "./CommitmentConfig.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports